import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-physical-violence-form',
  templateUrl: './physical-violence-form.component.html',
  styleUrls: ['./physical-violence-form.component.scss'],
})
export class PhysicalViolenceFormComponent implements OnInit {
  physicalViolenceForm: FormGroup;
  @Output() hasValidPhysicalViolence = new EventEmitter<boolean>();
  @Output() data = new EventEmitter();
  nullControls: string[] = [
    'HasPushed', 'HasPushedOther', 'HasPushedWithChild',
    'HasGrabbed', 'HasGrabbedOther', 'HasGrabbedWithChild',
    'HasPulledHair', 'HasPulledHairOther', 'HasPulledHairWithChild',
    'HasChoked', 'HasChokedOther', 'HasChokedWithChild',
    'HasDroveRecklessly', 'HasDroveRecklesslyOther', 'HasDroveRecklesslyWithChild',
    'HasBurned', 'HasBurnedOther', 'HasBurnedWithChild',
    'HasThrown', 'HasThrownOther', 'HasThrownWithChild',
    'HasForced', 'HasForcedOther', 'HasForcedWithChild',
    'HasBrokenBones', 'HasBrokenBonesOther', 'HasBrokenBonesWithChild',
    'HasUsedWeapons', 'HasUsedWeaponsOther', 'HasUsedWeaponsWithChild',
    'HasDestroyed', 'HasDestroyedOther', 'HasDestroyedWithChild',
    'HasAbused', 'HasAbusedOther', 'HasAbusedWithChild'
  ];
 violenceETypes = [
    { label: 'Pushed, shoved, or slapped', labelSpanish: 'Empujado/a, empujado/a o abofeteado/a', controls: { has: 'HasPushed', hasOther: 'HasPushedOther', withChild: 'HasPushedWithChild', times: 'PushedTimes', timesPrior: 'PushedTimesPrior' } },
    { label: 'Grabbed, dragged, or kicked', labelSpanish: 'Agarrado/a, arrastrado/a o pateado/a', controls: { has: 'HasGrabbed', hasOther: 'HasGrabbedOther', withChild: 'HasGrabbedWithChild', times: 'GrabbedTimes', timesPrior: 'GrabbedTimesPrior' } },
    { label: 'Pulled hair, bit', labelSpanish: 'Jalón de cabello, morder', controls: { has: 'HasPulledHair', hasOther: 'HasPulledHairOther', withChild: 'HasPulledHairWithChild', times: 'PulledHairTimes', timesPrior: 'PulledHairTimesPrior' } },
    { label: 'Choked, strangled', labelSpanish: 'Asfixiar, estrangular', controls: { has: 'HasChoked', hasOther: 'HasChokedOther', withChild: 'HasChokedWithChild', times: 'ChokedTimes', timesPrior: 'ChokedTimesPrior' } },
    { label: 'Drove recklessly to frighten', labelSpanish: 'Condujo imprudentemente para asusta', controls: { has: 'HasDroveRecklessly', hasOther: 'HasDroveRecklesslyOther', withChild: 'HasDroveRecklesslyWithChild', times: 'DroveRecklesslyTimes', timesPrior: 'DroveRecklesslyTimesPrior' } },
    { label: 'Burned other party', labelSpanish: 'Quemó a la otra parte', controls: { has: 'HasBurned', hasOther: 'HasBurnedOther', withChild: 'HasBurnedWithChild', times: 'BurnedTimes', timesPrior: 'BurnedTimesPrior' } }
  ];

  violenceOTypes = [
    { label: 'Threw an object', labelSpanish: 'Tirar un objeto', controls: { has: 'HasThrown', hasOther: 'HasThrownOther', withChild: 'HasThrownWithChild', times: 'ThrownTimes', timesPrior: 'ThrownTimesPrior' } },
    { label: 'Destroyed property', labelSpanish: 'Propiedad destruida', controls: { has: 'HasDestroyed', hasOther: 'HasDestroyedOther', withChild: 'HasDestroyedWithChild', times: 'DestroyedTimes', timesPrior: 'DestroyedTimesPrior' } },
    { label: 'Received broken bones or head injury', labelSpanish: 'Recibió huesos rotos o lesiones en la cabeza', controls: { has: 'HasBrokenBones', hasOther: 'HasBrokenBonesOther', withChild: 'HasBrokenBonesWithChild', times: 'BrokenBonesTimes', timesPrior: 'BrokenBonesTimesPrior' } },
    { label: 'Physically forced sex, reproductive coercion', labelSpanish: 'Sexo físicamente forzado, coerción reproductiva', controls: { has: 'HasForced', hasOther: 'HasForcedOther', withChild: 'HasForcedWithChild', times: 'ForcedTimes', timesPrior: 'ForcedTimesPrior' } },
    { label: 'Has Used Weapons', labelSpanish: 'Empujado/a, empujado/a o abofeteado/a', controls: { has: 'HasUsedWeapons', hasOther: 'HasUsedWeaponsOther', withChild: 'HasUsedWeaponsWithChild', times: 'UsedWeaponsTimes', timesPrior: 'UsedWeaponsTimesPrior' } },
    { label: 'Abused during pregnancy', labelSpanish: 'Abusada durante el embarazo', controls: { has: 'HasAbused', hasOther: 'HasAbusedOther', withChild: 'HasAbusedWithChild', times: 'AbusedTimes', timesPrior: 'AbusedTimesPrior' } },
  ];

	constructor(private _formBuilder: FormBuilder) { }

	ngOnInit(): void {
    this.physicalViolenceForm = this._formBuilder.group({
      HasPushed: [null],
      HasPushedOther: [null],
      HasPushedWithChild: [null],
      PushedTimes: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],
      PushedTimesPrior: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],

      HasGrabbed: [null],
      HasGrabbedOther: [null],
      HasGrabbedWithChild: [null],
      GrabbedTimes: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],
      GrabbedTimesPrior: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],

      HasPulledHair: [null],
      HasPulledHairOther: [null],
      HasPulledHairWithChild: [null],
      PulledHairTimes: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],
      PulledHairTimesPrior: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],

      HasChoked: [null],
      HasChokedOther: [null],
      HasChokedWithChild: [null],
      ChokedTimes: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],
      ChokedTimesPrior: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],

      HasDroveRecklessly: [null],
      HasDroveRecklesslyOther: [null],
      HasDroveRecklesslyWithChild: [null],
      DroveRecklesslyTimes: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],
      DroveRecklesslyTimesPrior: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],

      HasBurned: [null],
      HasBurnedOther: [null],
      HasBurnedWithChild: [null],
      BurnedTimes: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],
      BurnedTimesPrior: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],

      HasThrown: [null],
      HasThrownOther: [null],
      HasThrownWithChild: [null],
      ThrownTimes: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],
      ThrownTimesPrior: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],

      HasForced: [null],
      HasForcedOther: [null],
      HasForcedWithChild: [null],
      ForcedTimes: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],
      ForcedTimesPrior: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],

      HasBrokenBones: [null],
      HasBrokenBonesOther: [null],
      HasBrokenBonesWithChild: [null],
      BrokenBonesTimes: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],
      BrokenBonesTimesPrior: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],

      HasUsedWeapons: [null],
      HasUsedWeaponsOther: [null],
      HasUsedWeaponsWithChild: [null],
      UsedWeaponsTimes: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],
      UsedWeaponsTimesPrior: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],

      HasDestroyed: [null],
      HasDestroyedOther: [null],
      HasDestroyedWithChild: [null],
      DestroyedTimes: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],
      DestroyedTimesPrior: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],

      HasAbused: [null],
      HasAbusedOther: [null],
      HasAbusedWithChild: [null],
      AbusedTimes: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],
      AbusedTimesPrior: ['', [Validators.pattern(/^(0|[1-9]\d*)$/)]],

      HasChildHarmed: [null],
      HasReceivedCare: [null],
      IsCurrentlyInDomesticShelter: [null],

		})

    this.hasValidPhysicalViolence.emit(this.physicalViolenceForm.valid);

    this.physicalViolenceForm.statusChanges.subscribe((res) => {
      this.hasValidPhysicalViolence.emit(this.physicalViolenceForm.valid);
    })

    this.physicalViolenceForm.valueChanges.subscribe(res => {
			this.data.emit(res);
    })
    
    this.nullControls.forEach(controlName => this.subscribeToValueChanges(controlName));

    this.addConditionalValidators();
	}

  private subscribeToValueChanges(controlName: string): void {
    this.physicalViolenceForm.get(controlName).valueChanges.subscribe(value => {
      const newValue = value ? "true" : null;
      if (this.physicalViolenceForm.get(controlName).value !== newValue) {
        this.physicalViolenceForm.get(controlName).setValue(newValue, { emitEvent: false });
      }
    });
  }

  private addConditionalValidators(): void {
    const abuseTypes = [
      'Pushed', 'Grabbed', 'PulledHair', 'Choked',
      'DroveRecklessly', 'Burned', 'Thrown', 'Forced', 'BrokenBones',
      'UsedWeapons', 'Destroyed', 'Abused'
    ];

    abuseTypes.forEach((type) => {
      const hasControlNames = [
        `Has${type}`, `Has${type}Other`, `Has${type}WithChild`
      ];
      const timesControl = this.physicalViolenceForm.get(`${type}Times`);
      const timesPriorControl = this.physicalViolenceForm.get(`${type}TimesPrior`);

      hasControlNames.forEach((controlName) => {
        this.physicalViolenceForm.get(controlName).valueChanges.subscribe(() => {
          const anyChecked = hasControlNames.some(name => this.physicalViolenceForm.get(name).value);

          if (anyChecked) {
            timesControl.setValidators([Validators.required, Validators.pattern(/^(0|[1-9]\d*)$/)]);
            timesPriorControl.setValidators([Validators.required, Validators.pattern(/^(0|[1-9]\d*)$/)]);
          } else {
            timesControl.setValidators([Validators.pattern(/^(0|[1-9]\d*)$/)]);
            timesPriorControl.setValidators([Validators.pattern(/^(0|[1-9]\d*)$/)]);
          }

          timesControl.updateValueAndValidity();
          timesPriorControl.updateValueAndValidity();
        });
      });
    });
  }
}
